import { create, IStartInteractionOptions, IEndInteractionOptions } from '@wix/fedops-logger';
import { noop } from 'ramda-adjunct';
import { areTrackersEnabled } from '../../monitoring/utils';
import { FedOpsInteraction } from '../../constants/FedOpsInteraction';

const APP_NAME = 'media-manager-g6' as const;

interface FedopsLogger {
  interactionStarted: (name: FedOpsInteraction, startInteractionOptions?: Partial<IStartInteractionOptions>) => void;
  interactionEnded: (name: FedOpsInteraction, endInteractionOptions?: Partial<IEndInteractionOptions>) => void;
  appLoaded: () => void;
}

function createFakeLogger(): FedopsLogger {
  return {
    interactionStarted: noop,
    interactionEnded: noop,
    appLoaded: noop,
  };
}

export const fedopsLogger: FedopsLogger = areTrackersEnabled() ? create(APP_NAME) : createFakeLogger();
